module.exports = __webpack_public_path__ + "static/media/rsz_sociedades.89d21e1d.jpg";